/**
 * Voluum-style General / Tracking tabs for lander editor.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { cn } from '@/lib/utils';

export type LanderEditSubTab = 'general' | 'tracking';

export interface LanderEditTabBarProps {
  tab: LanderEditSubTab;
  onTab: (tab: LanderEditSubTab) => void;
}

const LanderEditTabBar: FC<LanderEditTabBarProps> = ({ tab, onTab }) => (
  <div
    className="flex border-b border-border text-xs font-semibold uppercase tracking-wide"
    role="tablist"
  >
    {(
      [
        { id: 'general' as const, label: 'General' },
        { id: 'tracking' as const, label: 'Tracking' },
      ] satisfies { id: LanderEditSubTab; label: string }[]
    ).map(({ id, label }, i) => (
      <button
        key={id}
        type="button"
        role="tab"
        aria-selected={tab === id}
        className={cn(
          'flex-1 px-3 py-2 transition-colors',
          i === 1 && 'border-l border-border',
          tab === id
            ? '-mb-px border-b-2 border-primary bg-primary/5 text-primary'
            : 'border-b-2 border-transparent text-muted-foreground hover:text-foreground',
        )}
        onClick={() => onTab(id)}
      >
        {label}
      </button>
    ))}
  </div>
);

export default LanderEditTabBar;
